module.exports = __webpack_public_path__ + "img/13_43.8937dc33.png";